import React from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import BrandHomeLink from "./BrandHomeLink";

export default function GatewayArrival({ brand, onEnter }) {
  return (
    <section className="gatewayArrival" aria-labelledby="gateway-arrival-title">
      <h1 id="gateway-arrival-title" className="srOnly">Enter {brand.name}</h1>

      <BrandHomeLink
        brand={brand}
        className="gatewayArrival__lockup"
        ariaLabel={`Go to ${brand.name} home`}
      >
        <img src={brand.arrivalLockup} alt={`${brand.name}. ${brand.arrivalTagline}`} />
      </BrandHomeLink>

      <p className="gatewayArrival__subtitle">Continue into your digital ecosystem.</p>

      <div className="gatewayArrival__action">
        <button
          type="button"
          className="gatewayArrival__button"
          onClick={onEnter}
          aria-label={`Enter ${brand.name}`}
        >
          <ArrowForwardRoundedIcon className="gatewayArrival__arrow" aria-hidden="true" />
        </button>
        <span>Enter {brand.name}</span>
      </div>

      <div className="gatewayArrival__trust" aria-label="Secure, private, always yours">
        <LockOutlinedIcon className="gatewayArrival__lock" aria-hidden="true" />
        <span>Secure</span><span>•</span><span>Private</span><span>•</span><span>Always Yours</span>
      </div>
    </section>
  );
}
